import { create } from 'zustand'

export interface OrganizationFromState {
  id: string
  name: string
  federalTaxId: string
}

interface ContractState {
  actualTab: number
  rollbackUrl: string
  actualOrganization: OrganizationFromState
  contractTagName: string
  viewMode: string
  updateViewMode: (newViewMode: string) => void
  updateTab: (tab: number) => void
  setRollbackUrl: (url: string) => void
  updateOrganization: (organization: OrganizationFromState) => void
  updateContractTagName: (tag: string) => void
  handleResetActualOrganization: () => void
}

const useContract = create<ContractState>((set) => ({
  actualTab: 0,
  rollbackUrl: '',
  actualOrganization: {} as OrganizationFromState,
  contractTagName: '',
  viewMode: 'table',
  updateViewMode: (newViewMode) => set({ viewMode: newViewMode }),
  updateTab: (tab) => set({ actualTab: tab }),
  setRollbackUrl: (url) => set({ rollbackUrl: url }),
  updateOrganization: (organization) => set({ actualOrganization: organization }),
  updateContractTagName: (tag) => set({ contractTagName: tag }),
  handleResetActualOrganization: () => set({ actualOrganization: {} as OrganizationFromState }),
}))

export default useContract
